const SITE_ACCOUNTS = {
    afl: {
        dev: [
            {
                name: 'AFL',
                icon: '/afl.svg',
                url: 'https://exp.afl.dev.pulselive.com',
                featured: true
            },
            {
                name: 'AFLW',
                icon: '/afl.svg',
                url: 'https://exp.aflw.dev.pulselive.com',
                featured: true
            },
            {
                name: 'Marvel Stadium',
                url: 'https://marvelstadium.dev.pulselive.com'
            },
            {
                name: 'Geelong Cats',
                icon: '/geelong.svg',
                url: 'https://exp.aflc-geel.dev.pulselive.com'
            },
            {
                name: 'Goldcoast Suns',
                icon: '/suns.svg',
                url: 'https://exp.aflc-gcfc.dev.pulselive.com'
            }
        ],
        test: [
            {
                name: 'AFL',
                icon: '/afl.svg',
                url: 'https://exp.afl.test.pulselive.com',
                featured: true
            },
            {
                name: 'AFLW',
                icon: '/afl.svg',
                url: 'https://exp.aflw.test.pulselive.com',
                featured: true
            },
            {
                name: 'Marvel Stadium',
                url: 'https://marvelstadium.test.pulselive.com'
            },
            {
                name: 'Geelong Cats',
                icon: '/geelong.svg',
                url: 'https://exp.aflc-geel.test.pulselive.com'
            },
            {
                name: 'Goldcoast Suns',
                icon: '/suns.svg',
                url: 'https://exp.aflc-gcfc.test.pulselive.com'
            }
        ],
        uat: [
            {
                name: 'AFL',
                icon: '/afl.svg',
                url: 'https://exp.afl.uat1.testafl.com',
                featured: true
            },
            {
                name: 'AFL On Demand',
                icon: '/afl-ondemand.svg',
                url: 'https://exp.ondemand.afl.uat1.testafl.com',
                featured: true
            },
            {
                name: 'Marvel Stadium',
                icon: '/marvelstadium.svg',
                url: 'https://exp.marvelstadium.uat1.testmediaservices.com.au',
                featured: true
            },
            {
                name: 'Adelaide Crows',
                icon: '/adelaide.svg',
                url: 'https://exp.afc.uat1.testafl.com'
            },
            {
                name: 'Brisbane Lions',
                icon: '/brisbane.svg',
                url: 'https://exp.lions.uat1.testafl.com'
            },
            {
                name: 'Carlton Blues',
                icon: '/carlton.svg',
                url: 'https://exp.carltonfc.uat1.testafl.com'
            },
            {
                name: 'Collingwood',
                icon: '/collingwood.svg',
                url: 'https://exp.collingwoodfc.uat1.testafl.com'
            },
            {
                name: 'Essendon',
                icon: '/essendon.svg',
                url: 'https://exp.essendonfc.uat1.testafl.com'
            },
            {
                name: 'Fremantle Dockers',
                icon: '/fremantle.svg',
                url: 'https://exp.fremantlefc.uat1.testafl.com'
            },
            {
                name: 'Geelong Cats',
                icon: '/geelong.svg',
                url: 'https://exp.geelongcats.uat1.testafl.com'
            },
            {
                name: 'Goldcoast Suns',
                icon: '/suns.svg',
                url: 'https://exp.goldcoastfc.uat1.testafl.com'
            },
            {
                name: 'GWS',
                icon: '/gws.png',
                url: 'https://exp.gwsgiants.uat1.testafl.com'
            },
            {
                name: 'Hawthorn',
                icon: '/hawthorn.svg',
                url: 'https://exp.hawthornfc.uat1.testafl.com'
            },
            {
                name: 'Melbourne',
                icon: '/melbourne.svg',
                url: 'https://exp.melbournefc.uat1.testafl.com'
            },
            {
                name: 'North Melbourne',
                icon: '/north-melbourne.svg',
                url: 'https://exp.nmfc.uat1.testafl.com'
            },
            {
                name: 'Port Adelaide',
                icon: '/port-adelaide.svg',
                url: 'https://exp.portadelaidefc.uat1.testafl.com'
            },
            {
                name: 'Richmond',
                icon: '/richmond.svg',
                url: 'https://exp.richmondfc.uat1.testafl.com'
            },
            {
                name: 'St Kilda',
                icon: '/stkilda.svg',
                url: 'https://exp.saints.uat1.testafl.com'
            },
            {
                name: 'Sydney Swans',
                icon: '/sydney.svg',
                url: 'https://exp.sydneyswans.uat1.testafl.com'
            },
            {
                name: 'West Coast',
                icon: '/west-coast.svg',
                url: 'https://exp.westcoasteagles.uat1.testafl.com'
            },
            {
                name: 'Western Bulldogs',
                icon: '/western-bulldogs.svg',
                url: 'https://exp.westernbulldogs.uat1.testafl.com'
            }
        ],
        production: [
            {
                name: 'AFL',
                icon: '/afl.svg',
                url: 'https://exp.afl.com.au',
                featured: true
            },
            {
                name: 'AFL On Demand',
                icon: '/afl-ondemand.svg',
                url: 'https://exp.ondemand.afl.com.au',
                featured: true
            },
            {
                name: 'Marvel Stadium',
                icon: '/marvelstadium.svg',
                url: 'https://exp.marvelstadium.com.au',
                featured: true
            },
            {
                name: 'Adelaide Crows',
                icon: '/adelaide.svg',
                url: 'https://exp.afc.com.au'
            },
            {
                name: 'Brisbane Lions',
                icon: '/brisbane.svg',
                url: 'https://exp.lions.com.au'
            },
            {
                name: 'Carlton Blues',
                icon: '/carlton.svg',
                url: 'https://exp.carltonfc.com.au'
            },
            {
                name: 'Collingwood',
                icon: '/collingwood.svg',
                url: 'https://exp.collingwoodfc.com.au'
            },
            {
                name: 'Essendon',
                icon: '/essendon.svg',
                url: 'https://exp.essendonfc.com.au'
            },
            {
                name: 'Fremantle Dockers',
                icon: '/fremantle.svg',
                url: 'https://exp.fremantlefc.com.au'
            },
            {
                name: 'Geelong Cats',
                icon: '/geelong.svg',
                url: 'https://exp.geelongcats.com.au'
            },
            {
                name: 'Goldcoast Suns',
                icon: '/suns.svg',
                url: 'https://exp.goldcoastfc.com.au'
            },
            {
                name: 'GWS',
                icon: '/gws.png',
                url: 'http://exp.gwsgiants.com.au'
            },
            {
                name: 'Hawthorn',
                icon: '/hawthorn.svg',
                url: 'https://exp.hawthornfc.com.au'
            },
            {
                name: 'Melbourne',
                icon: '/melbourne.svg',
                url: 'https://exp.melbournefc.com.au'
            },
            {
                name: 'North Melbourne',
                icon: '/north-melbourne.svg',
                url: 'https://exp.nmfc.com.au'
            },
            {
                name: 'Port Adelaide',
                icon: '/port-adelaide.svg',
                url: 'https://exp.portadelaidefc.com.au'
            },
            {
                name: 'Richmond',
                icon: '/richmond.svg',
                url: 'https://exp.richmondfc.com.au'
            },
            {
                name: 'St Kilda',
                icon: '/stkilda.svg',
                url: 'https://exp.saints.com.au'
            },
            {
                name: 'Sydney Swans',
                icon: '/sydney.svg',
                url: 'https://exp.sydneyswans.com.au'
            },
            {
                name: 'West Coast',
                icon: '/west-coast.svg',
                url: 'https://exp.westcoasteagles.com.au'
            },
            {
                name: 'Western Bulldogs',
                icon: '/western-bulldogs.svg',
                url: 'https://exp.westernbulldogs.com.au'
            }
        ]
    }
}

const getSiteAccounts = ( account, env ) => {
    const aflRealmNames = [ 'afl', 'uat-main', 'uat-clubs', 'prod-main', 'prod-clubs' ];
    
    let useAccount = account;
    if ( aflRealmNames.includes( account ) ) {
        useAccount = 'afl';
    }

    if ( !SITE_ACCOUNTS[ useAccount ] ) {
        return null;
    }

    let useEnv = env;
    if ( window.location.hostname.includes('uat1') ) {
        useEnv = 'uat';
    }

    return SITE_ACCOUNTS[useAccount][useEnv];
}

export { getSiteAccounts }